import {fetchConfigVars} from "../../api/config/configService";

const state = {
    fetchConfigVarsError: '',
    firebase: {},
    customerSuccess: {},
    paystack: {}
};

const mutations = {

    SET_CONFIG_VARS_SUCCESS(state, _data) {
        state.fetchConfigVarsError = null;
        for (let configKey in _data) {
            state[configKey] = _data[configKey];
        }
    },
    SET_CONFIG_VARS_FAILED(state, message) {
        state.fetchConfigVarsError = message;
    }
};

const actions = {

    async fetchConfigVars({commit}) {

        try {

            const configVars = await fetchConfigVars();
            commit("SET_CONFIG_VARS_SUCCESS", configVars.response.data);

        } catch (e) {
            commit("SET_CONFIG_VARS_FAILED", e.message);
            console.log(e.message);
        }
    }
};

export default {
    state,
    mutations,
    actions
};
